import requestAction from '../../utils/requestAction'
import { LinkedVendorsInput } from '../../models/LinkedVendors';

export const upsertLinkedVendor = (linkedVendor: LinkedVendorsInput, handleResponse?: () => void) =>
  requestAction('LINKED_VENDORS_UPSERT')(
    `linkedVendors${(linkedVendor as LinkedVendorsInput).id ? `/${(linkedVendor as LinkedVendorsInput).id}` : ''}`,
    (linkedVendor as LinkedVendorsInput).id ? 'PUT' : 'POST',
    linkedVendor,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse() })
